import React from "react";

const AwsDashboard = () => {
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: "auto",
      }}
    >
      <h1>
        Welcome to the <span style={{ color: "#0D6EFD" }}>AWS</span>
      </h1>
      <h2
        style={{
          color: "rgb(211, 32, 32)",
        }}
      >
        Dashboard
      </h2>
    </div>
  );
};

export default AwsDashboard;
